import { useQuery } from '@tanstack/react-query'

import axiosInstance from '@/libs/configs/axios'
import { apiUrl } from '@/libs/constants'
import { TApiResult } from '@/libs/types/global.types'

export const NOTIFICATION_SETTINGS_QUERY_KEY = 'notifications_settings'

export const getNotificationSettingsQuery = async (): Promise<TApiResult<any>> => {
  try {
    const response = await axiosInstance({
      baseURL: apiUrl,
      url: `/user/notification-setting`,
      method: 'GET',
    })

    return response?.data
  } catch (error: any) {
    return error?.response?.data
  }
}

const useGetNotificationSettingsQuery = () => {
  return useQuery({
    queryKey: [NOTIFICATION_SETTINGS_QUERY_KEY],
    queryFn: () => getNotificationSettingsQuery(),
    staleTime: 15 * 60000,
  })
}

export default useGetNotificationSettingsQuery
